/* NOVA — REGALOS POR TRANSFERENCIA V19 */

(function () {
  'use strict';

  if (window.__NOVA_GIFT_SYSTEM_V19__) return;
  window.__NOVA_GIFT_SYSTEM_V19__ = true;

  /* ========================================================
     CONFIGURACIÓN
     ======================================================== */

  const CONFIG = {
    // El popup se desbloquea al llegar a la 4.ª pieza normal.
    POPUP_TRIGGER_ITEMS: 4,

    // Si ya tiene regalo, se conserva con 3 piezas.
    // Si baja a 2, 1 o 0, el regalo se elimina automáticamente.
    GIFT_KEEP_MINIMUM_ITEMS: 3,

    DISMISSED_KEY: 'novaGiftPopupDismissedV19',

    GIFTS: {
      OWALA_GRANDE: {
        id: 43111970472007,
        label: 'Owala grande',
        productHandle: 'owala-de-regalo'
      },

      OWALA_CHICO: {
        id: 43111970504775,
        label: 'Owala chico',
        productHandle: 'owala-de-regalo'
      },

      SEPHORA: {
        id: 43111970930759,
        label: 'Sephora Getaway Set',
        productHandle: 'sephora-getaway-set-de-regalo'
      }
    }
  };

  const GIFTS = Object.values(CONFIG.GIFTS);

  const GIFT_IDS = GIFTS.map(function (gift) {
    return Number(gift.id);
  });

  const GIFT_HANDLES = Array.from(
    new Set(
      GIFTS.map(function (gift) {
        return String(gift.productHandle).toLowerCase();
      })
    )
  );

  const ROOT =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  const URLS = {
    cart: ROOT + 'cart.js',
    add: ROOT + 'cart/add.js',
    change: ROOT + 'cart/change.js'
  };

  const nativeFetch = window.fetch.bind(window);

  let syncing = false;
  let mutating = false;
  let syncTimer = null;
  let lastCartHadGift = false;
  let imagesRequested = false;

  /* ========================================================
     PETICIONES
     ======================================================== */

  async function requestJson(url, options) {
    const response = await nativeFetch(url, options);
    const text = await response.text();

    let data = null;

    if (text) {
      try {
        data = JSON.parse(text);
      } catch (error) {
        data = {
          description: text
        };
      }
    }

    if (!response.ok) {
      const message =
        data &&
        (
          data.description ||
          data.message
        )
          ? String(
              data.description ||
              data.message
            )
          : 'No se pudo actualizar el carrito.';

      const error =
        new Error(message);

      error.status =
        response.status;

      error.data =
        data;

      throw error;
    }

    return data;
  }

  /* ========================================================
     CARRITO
     ======================================================== */

  function getCart() {
    return requestJson(
      URLS.cart +
        '?nova_gift=' +
        Date.now(),
      {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      }
    );
  }

  function changeCartLine(
    lineKey,
    quantity
  ) {
    return requestJson(
      URLS.change,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type':
            'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      }
    );
  }

  function addGiftToCart(
    gift
  ) {
    return requestJson(
      URLS.add,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type':
            'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: gift.id,
              quantity: 1,

              properties: {
                _nova_gift:
                  '1',

                _nova_gift_choice:
                  gift.label,

                _nova_transfer_only:
                  '1',

                _nova_gift_rule:
                  'Se activa desde 4 piezas · se conserva con mínimo 3'
              }
            }
          ]
        })
      }
    );
  }

  /* ========================================================
     DETECTAR REGALOS
     ======================================================== */

  function cartItems(
    cart
  ) {
    return (
      cart &&
      Array.isArray(
        cart.items
      )
    )
      ? cart.items
      : [];
  }

  function isGiftItem(
    item
  ) {
    if (!item) {
      return false;
    }

    const properties =
      item.properties || {};

    const variantId =
      Number(
        item.variant_id ||
        item.id ||
        0
      );

    const handle =
      String(
        item.handle || ''
      ).toLowerCase();

    return (
      GIFT_IDS.includes(
        variantId
      )

      ||

      GIFT_HANDLES.includes(
        handle
      )

      ||

      properties._nova_gift ===
        '1'

      ||

      properties._nova_gift ===
        1

      ||

      properties._nova_gift ===
        true
    );
  }

  function giftLines(
    cart
  ) {
    return cartItems(
      cart
    ).filter(
      isGiftItem
    );
  }

  /*
    Cuenta únicamente productos normales.
    El regalo NO cuenta dentro de las piezas.
  */

  function eligibleQuantity(
    cart
  ) {
    return cartItems(
      cart
    ).reduce(
      function (
        total,
        item
      ) {
        if (
          isGiftItem(
            item
          )
        ) {
          return total;
        }

        return (
          total +
          Math.max(
            0,
            Number(
              item.quantity ||
              0
            )
          )
        );
      },
      0
    );
  }

  /* ========================================================
     REGLAS DEL REGALO
     ======================================================== */

  async function enforceGiftRules(
    cart
  ) {
    const gifts =
      giftLines(
        cart
      );

    const eligible =
      eligibleQuantity(
        cart
      );

    let changed =
      false;

    if (
      !gifts.length
    ) {
      return {
        cart: cart,
        changed: false
      };
    }

    /*
      REGLA:

      3 piezas:
      el regalo permanece.

      2, 1 o 0 piezas:
      el regalo se elimina automáticamente.
    */

    if (
      eligible <
      CONFIG.GIFT_KEEP_MINIMUM_ITEMS
    ) {
      for (
        const line
        of gifts
      ) {
        await changeCartLine(
          line.key,
          0
        );

        changed =
          true;
      }

      return {
        cart:
          changed
            ? await getCart()
            : cart,

        changed:
          changed
      };
    }

    /*
      La cantidad del regalo
      siempre debe ser 1.
    */

    if (
      Number(
        gifts[0].quantity ||
        0
      ) !== 1
    ) {
      await changeCartLine(
        gifts[0].key,
        1
      );

      changed =
        true;
    }

    /*
      Máximo un regalo.
    */

    for (
      let index = 1;
      index < gifts.length;
      index += 1
    ) {
      await changeCartLine(
        gifts[index].key,
        0
      );

      changed =
        true;
    }

    return {
      cart:
        changed
          ? await getCart()
          : cart,

      changed:
        changed
    };
  }

  /* ========================================================
     ELIMINAR POPUPS ANTERIORES
     ======================================================== */

  function removeLegacyPopups() {
    const selectors = [
      '.bb-transfer-gift-popup',
      '.bb-gift-popup',
      '.gift-popup',
      '.transfer-gift-popup',
      '[data-bb-transfer-gift-popup]',
      '[data-transfer-gift-popup]',
      '[data-gift-popup]',
      '#bb-gift-popup-controlled'
    ];

    document
      .querySelectorAll(
        selectors.join(',')
      )
      .forEach(
        function (
          element
        ) {
          element.remove();
        }
      );
  }

  /* ========================================================
     CREAR POPUP

     Se mantienen las clases V18 porque
     el CSS existente utiliza esas clases.
     ======================================================== */

  function createPopup() {
    let popup =
      document.getElementById(
        'nova-gift-popup-v18'
      );

    if (popup) {
      return popup;
    }

    popup =
      document.createElement(
        'div'
      );

    popup.id =
      'nova-gift-popup-v18';

    popup.className =
      'nova-gift-popup-v18';

    popup.setAttribute(
      'role',
      'dialog'
    );

    popup.setAttribute(
      'aria-label',
      'Elige tu regalo NOVA'
    );

    popup.setAttribute(
      'aria-hidden',
      'true'
    );

    popup.innerHTML = `

      <button
        type="button"
        class="nova-gift-popup-v18__close"
        data-nova-gift-close
        aria-label="Cerrar"
      >
        ×
      </button>


      <span
        class="nova-gift-popup-v18__eyebrow"
      >
        REGALO POR TRANSFERENCIA
      </span>


      <h2>
        Elige tu regalo
      </h2>


      <p
        class="nova-gift-popup-v18__intro"
      >
        Ya agregaste
        <strong>
          4 piezas o más.
        </strong>

        Elige uno de nuestros regalos
        disponibles para acompañar tu pedido.
      </p>


      <div
        class="nova-gift-popup-v18__choices"
      >


        <!-- ==========================
             OWALA
        =========================== -->

        <article
          class="nova-gift-option"
        >

          <div
            class="nova-gift-option__media"
          >

            <span
              class="nova-gift-option__placeholder"
              data-owala-placeholder
            >
              Cargando…
            </span>


            <img
              data-owala-image
              alt="Owala de regalo"
              loading="eager"
              hidden
            >

          </div>


          <span
            class="nova-gift-option__type"
          >
            OPCIÓN 1
          </span>


          <h3>
            Owala de regalo
          </h3>


          <p>
            Elige el tamaño.
            Al confirmar tu pedido
            te enviaremos mensaje
            para mostrarte los colores disponibles.
          </p>


          <div
            class="nova-gift-option__actions"
          >

            <button
              type="button"
              class="nova-gift-choice"
              data-nova-gift-choice="OWALA_GRANDE"
            >
              Grande
            </button>


            <button
              type="button"
              class="nova-gift-choice"
              data-nova-gift-choice="OWALA_CHICO"
            >
              Chico
            </button>

          </div>

        </article>


        <!-- ==========================
             SEPHORA
        =========================== -->

        <article
          class="nova-gift-option"
        >

          <div
            class="nova-gift-option__media"
          >

            <span
              class="nova-gift-option__placeholder"
              data-sephora-placeholder
            >
              Cargando…
            </span>


            <img
              data-sephora-image
              alt="Sephora Getaway Set de regalo"
              loading="eager"
              hidden
            >

          </div>


          <span
            class="nova-gift-option__type"
          >
            OPCIÓN 2
          </span>


          <h3>
            Sephora Getaway Set
          </h3>


          <p>
            Set Sephora de regalo.
            Una unidad por pedido,
            sujeto a disponibilidad.
          </p>


          <div
            class="
              nova-gift-option__actions
              nova-gift-option__actions--single
            "
          >

            <button
              type="button"
              class="nova-gift-choice"
              data-nova-gift-choice="SEPHORA"
            >
              Elegir Sephora
            </button>

          </div>

        </article>


      </div>


      <div
        class="nova-gift-popup-v18__transfer"
      >

        <span
          class="nova-gift-popup-v18__transfer-icon"
        >
          ✦
        </span>


        <div>

          <strong>
            Importante:
          </strong>

          el regalo es válido únicamente
          pagando tu pedido por transferencia.

          En cuanto confirmemos tu pedido,
          nos comunicaremos contigo
          para terminar de confirmar tu regalo.

        </div>

      </div>


      <small
        class="nova-gift-popup-v18__status"
        data-nova-gift-status
      >
        Máximo 1 regalo por carrito.
      </small>

    `;

    document.body.appendChild(
      popup
    );

    /*
      CERRAR
    */

    popup
      .querySelector(
        '[data-nova-gift-close]'
      )
      .addEventListener(
        'click',
        function () {
          sessionStorage.setItem(
            CONFIG.DISMISSED_KEY,
            '1'
          );

          hidePopup();
        }
      );

    /*
      BOTONES DE REGALO
    */

    popup
      .querySelectorAll(
        '[data-nova-gift-choice]'
      )
      .forEach(
        function (
          button
        ) {
          button.addEventListener(
            'click',
            function () {
              claimGift(
                button.getAttribute(
                  'data-nova-gift-choice'
                ),
                button
              );
            }
          );
        }
      );

    loadGiftImages();

    return popup;
  }

  /* ========================================================
     CARGAR IMÁGENES DE LOS PRODUCTOS
     ======================================================== */

  function normalizeImageUrl(
    url
  ) {
    const value =
      String(
        url || ''
      ).trim();

    if (!value) {
      return '';
    }

    if (
      value.indexOf('//') ===
      0
    ) {
      return (
        window.location.protocol +
        value
      );
    }

    return value;
  }

  async function getProductJson(
    handle
  ) {
    const response =
      await nativeFetch(
        ROOT +
          'products/' +
          handle +
          '.js?nova=' +
          Date.now(),
        {
          method: 'GET',

          credentials:
            'same-origin',

          cache:
            'no-store',

          headers: {
            Accept:
              'application/json'
          }
        }
      );

    if (
      !response.ok
    ) {
      throw new Error(
        'No se pudo cargar ' +
        handle
      );
    }

    return response.json();
  }

  function getProductImage(
    product
  ) {
    if (
      !product
    ) {
      return '';
    }

    if (
      product.featured_image
    ) {
      if (
        typeof
          product.featured_image ===
        'string'
      ) {
        return normalizeImageUrl(
          product.featured_image
        );
      }

      if (
        product.featured_image.src
      ) {
        return normalizeImageUrl(
          product.featured_image.src
        );
      }
    }

    if (
      Array.isArray(
        product.images
      ) &&
      product.images.length
    ) {
      const first =
        product.images[0];

      if (
        typeof first ===
        'string'
      ) {
        return normalizeImageUrl(
          first
        );
      }

      if (
        first &&
        first.src
      ) {
        return normalizeImageUrl(
          first.src
        );
      }
    }

    return '';
  }

  function setPopupImage(
    imageSelector,
    placeholderSelector,
    src
  ) {
    const popup =
      document.getElementById(
        'nova-gift-popup-v18'
      );

    if (
      !popup
    ) {
      return;
    }

    const image =
      popup.querySelector(
        imageSelector
      );

    const placeholder =
      popup.querySelector(
        placeholderSelector
      );

    if (
      !image
    ) {
      return;
    }

    if (
      !src
    ) {
      if (
        placeholder
      ) {
        placeholder.textContent =
          'Imagen no disponible';
      }

      return;
    }

    image.addEventListener(
      'load',
      function () {
        image.hidden =
          false;

        if (
          placeholder
        ) {
          placeholder.hidden =
            true;
        }
      },
      {
        once:
          true
      }
    );

    image.addEventListener(
      'error',
      function () {
        image.hidden =
          true;

        if (
          placeholder
        ) {
          placeholder.hidden =
            false;

          placeholder.textContent =
            'Imagen no disponible';
        }
      },
      {
        once:
          true
      }
    );

    image.src =
      src;
  }

  async function loadGiftImages() {
    if (
      imagesRequested
    ) {
      return;
    }

    imagesRequested =
      true;

    const results =
      await Promise.allSettled(
        [
          getProductJson(
            CONFIG.GIFTS
              .OWALA_GRANDE
              .productHandle
          ),

          getProductJson(
            CONFIG.GIFTS
              .SEPHORA
              .productHandle
          )
        ]
      );

    setPopupImage(
      '[data-owala-image]',
      '[data-owala-placeholder]',
      results[0].status ===
        'fulfilled'
        ? getProductImage(
            results[0].value
          )
        : ''
    );

    setPopupImage(
      '[data-sephora-image]',
      '[data-sephora-placeholder]',
      results[1].status ===
        'fulfilled'
        ? getProductImage(
            results[1].value
          )
        : ''
    );
  }

  /* ========================================================
     ESTADO DEL POPUP
     ======================================================== */

  function setPopupStatus(
    message,
    state
  ) {
    const status =
      createPopup()
        .querySelector(
          '[data-nova-gift-status]'
        );

    status.textContent =
      message;

    status.classList.remove(
      'is-error',
      'is-success'
    );

    if (
      state ===
      'error'
    ) {
      status.classList.add(
        'is-error'
      );
    }

    if (
      state ===
      'success'
    ) {
      status.classList.add(
        'is-success'
      );
    }
  }

  function setChoiceButtonsDisabled(
    disabled
  ) {
    createPopup()
      .querySelectorAll(
        '[data-nova-gift-choice]'
      )
      .forEach(
        function (
          button
        ) {
          button.disabled =
            Boolean(
              disabled
            );
        }
      );
  }

  function showPopup() {
    const popup =
      createPopup();

    setChoiceButtonsDisabled(
      false
    );

    setPopupStatus(
      'Máximo 1 regalo por carrito.',
      ''
    );

    window.requestAnimationFrame(
      function () {
        popup.classList.add(
          'is-visible'
        );

        popup.setAttribute(
          'aria-hidden',
          'false'
        );
      }
    );
  }

  function hidePopup() {
    const popup =
      document.getElementById(
        'nova-gift-popup-v18'
      );

    if (
      popup
    ) {
      popup.classList.remove(
        'is-visible'
      );

      popup.setAttribute(
        'aria-hidden',
        'true'
      );
    }
  }

  /* ========================================================
     DECORAR REGALO EN EL CARRITO
     ======================================================== */

  function decorateGiftInCart() {
    GIFT_HANDLES.forEach(
      function (
        handle
      ) {
        const selector =
          'a[href*="/products/' +
          handle +
          '"]';

        document
          .querySelectorAll(
            selector
          )
          .forEach(
            function (
              link
            ) {
              const cartLine =
                link.closest(
                  'tr, cart-item, .cart-item, [data-cart-item], li'
                )

                ||

                link.parentElement;

              if (
                !cartLine
              ) {
                return;
              }

              cartLine.classList.add(
                'nova-gift-cart-line'
              );

              let badge =
                cartLine.querySelector(
                  '.nova-gift-cart-badge'
                );

              if (
                !badge
              ) {
                badge =
                  document.createElement(
                    'span'
                  );

                badge.className =
                  'nova-gift-cart-badge';

                link.insertAdjacentElement(
                  'afterend',
                  badge
                );
              }

              badge.textContent =
                'REGALO · TRANSFERENCIA';

              cartLine
                .querySelectorAll(
                  [
                    'button[name="plus"]',

                    '[data-quantity-plus]',

                    'button[aria-label*="Aumentar"]',

                    'button[aria-label*="Increase"]'
                  ].join(',')
                )
                .forEach(
                  function (
                    button
                  ) {
                    button.disabled =
                      true;

                    button.setAttribute(
                      'aria-disabled',
                      'true'
                    );
                  }
                );
            }
          );
      }
    );
  }

  /* ========================================================
     ACTUALIZAR INTERFAZ DEL CARRITO
     ======================================================== */

  function announceCartUpdate(
    cart
  ) {
    [
      'cart:updated',
      'cart:refresh',
      'cart:update'
    ].forEach(
      function (
        eventName
      ) {
        document.dispatchEvent(
          new CustomEvent(
            eventName,
            {
              detail: {
                cart:
                  cart
              }
            }
          )
        );
      }
    );

    window.dispatchEvent(
      new CustomEvent(
        'nova:cart-changed',
        {
          detail: {
            cart:
              cart
          }
        }
      )
    );
  }

  /* ========================================================
     ELEGIR REGALO
     ======================================================== */

  async function claimGift(
    choiceKey,
    clickedButton
  ) {
    if (
      mutating
    ) {
      return;
    }

    const gift =
      CONFIG.GIFTS[
        choiceKey
      ];

    if (
      !gift
    ) {
      setPopupStatus(
        'No se pudo identificar el regalo.',
        'error'
      );

      return;
    }

    mutating =
      true;

    setChoiceButtonsDisabled(
      true
    );

    const originalText =
      clickedButton.textContent;

    clickedButton.textContent =
      'Agregando...';

    try {
      let cart =
        await getCart();

      /*
        Solo se puede ELEGIR un regalo
        al tener mínimo 4 piezas.
      */

      if (
        eligibleQuantity(
          cart
        ) <
        CONFIG.POPUP_TRIGGER_ITEMS
      ) {
        throw new Error(
          'Primero debes tener al menos 4 piezas en el carrito.'
        );
      }

      /*
        Ya existe un regalo.
      */

      if (
        giftLines(
          cart
        ).length
      ) {
        throw new Error(
          'Ya tienes un regalo agregado en tu carrito.'
        );
      }

      await addGiftToCart(
        gift
      );

      cart =
        await getCart();

      const enforced =
        await enforceGiftRules(
          cart
        );

      cart =
        enforced.cart;

      sessionStorage.removeItem(
        CONFIG.DISMISSED_KEY
      );

      clickedButton.textContent =
        'Regalo agregado ✓';

      setPopupStatus(
        gift.label +
          ' agregado a tu carrito.',
        'success'
      );

      announceCartUpdate(
        cart
      );

      decorateGiftInCart();

      window.setTimeout(
        hidePopup,
        850
      );
    } catch (
      error
    ) {
      console.error(
        'NOVA regalos:',
        error
      );

      clickedButton.textContent =
        originalText;

      setChoiceButtonsDisabled(
        false
      );

      let message =
        error &&
        error.message
          ? error.message
          : 'No se pudo agregar el regalo.';

      /*
        Shopify devuelve 422
        si una variante está agotada
        o no disponible.
      */

      if (
        error &&
        error.status ===
          422
      ) {
        message =
          'Ese regalo no está disponible en este momento. Elige otra opción.';
      }

      setPopupStatus(
        message,
        'error'
      );
    } finally {
      mutating =
        false;

      scheduleSync(
        500
      );
    }
  }

  /* ========================================================
     SINCRONIZACIÓN
     ======================================================== */

  async function syncGiftSystem() {
    if (
      syncing ||
      mutating
    ) {
      return;
    }

    syncing =
      true;

    try {
      removeLegacyPopups();

      let cart =
        await getCart();

      let eligible =
        eligibleQuantity(
          cart
        );

      /*
        Primero se revisa si el regalo
        todavía cumple la regla.

        Si baja a:
        2, 1 o 0 productos normales

        se elimina automáticamente.

        Si tiene exactamente 3:
        se conserva.
      */

      const enforced =
        await enforceGiftRules(
          cart
        );

      cart =
        enforced.cart;

      if (
        enforced.changed
      ) {
        announceCartUpdate(
          cart
        );
      }

      eligible =
        eligibleQuantity(
          cart
        );

      const hasGift =
        giftLines(
          cart
        ).length >
        0;

      /*
        MENOS DE 4:

        Todavía no se muestra el popup.

        Si ya había elegido un regalo
        y quedan exactamente 3 piezas,
        el regalo se conserva.

        Al bajar de 3,
        enforceGiftRules lo elimina.
      */

      if (
        eligible <
        CONFIG.POPUP_TRIGGER_ITEMS
      ) {
        sessionStorage.removeItem(
          CONFIG.DISMISSED_KEY
        );

        hidePopup();
      }

      /*
        YA TIENE REGALO:
        no mostrar popup.
      */

      else if (
        hasGift
      ) {
        hidePopup();
      }

      /*
        4 O MÁS Y SIN REGALO:
        mostrar popup.
      */

      else {
        /*
          Si quitó manualmente
          el regalo con 4 o más productos,
          permitir que vuelva a elegir.
        */

        if (
          lastCartHadGift &&
          !hasGift
        ) {
          sessionStorage.removeItem(
            CONFIG.DISMISSED_KEY
          );
        }

        const dismissed =
          sessionStorage.getItem(
            CONFIG.DISMISSED_KEY
          ) ===
          '1';

        if (
          dismissed
        ) {
          hidePopup();
        } else {
          showPopup();
        }
      }

      lastCartHadGift =
        hasGift;

      decorateGiftInCart();
    } catch (
      error
    ) {
      console.warn(
        'NOVA regalos: no se pudo sincronizar.',
        error
      );
    } finally {
      syncing =
        false;
    }
  }

  function scheduleSync(
    delay
  ) {
    window.clearTimeout(
      syncTimer
    );

    syncTimer =
      window.setTimeout(
        syncGiftSystem,

        typeof delay ===
        'number'
          ? delay
          : 180
      );
  }

  /* ========================================================
     ESCUCHAR CAMBIOS DE CARRITO
     ======================================================== */

  function requestUrl(
    request
  ) {
    if (
      typeof request ===
      'string'
    ) {
      return request;
    }

    if (
      request &&
      request.url
    ) {
      return request.url;
    }

    return '';
  }

  /* ========================================================
     FETCH
     ======================================================== */

  function installFetchListener() {
    if (
      window.__NOVA_GIFT_FETCH_V19__
    ) {
      return;
    }

    window.__NOVA_GIFT_FETCH_V19__ =
      true;

    window.fetch =
      function () {
        const args =
          Array.prototype.slice.call(
            arguments
          );

        const url =
          requestUrl(
            args[0]
          );

        const promise =
          nativeFetch.apply(
            window,
            args
          );

        if (
          /\/cart\/(?:add|change|update|clear)(?:\.js)?/i.test(
            url
          )
        ) {
          promise.finally(
            function () {
              scheduleSync(
                180
              );

              window.setTimeout(
                syncGiftSystem,
                550
              );
            }
          );
        }

        return promise;
      };
  }

  /* ========================================================
     XHR
     ======================================================== */

  function installXhrListener() {
    if (
      window.__NOVA_GIFT_XHR_V19__
    ) {
      return;
    }

    window.__NOVA_GIFT_XHR_V19__ =
      true;

    const originalOpen =
      XMLHttpRequest
        .prototype
        .open;

    const originalSend =
      XMLHttpRequest
        .prototype
        .send;

    XMLHttpRequest
      .prototype
      .open =
      function (
        method,
        url
      ) {
        this.__novaGiftUrl =
          String(
            url || ''
          );

        return originalOpen.apply(
          this,
          arguments
        );
      };

    XMLHttpRequest
      .prototype
      .send =
      function () {
        if (
          /\/cart\/(?:add|change|update|clear)(?:\.js)?/i.test(
            this.__novaGiftUrl ||
            ''
          )
        ) {
          this.addEventListener(
            'loadend',
            function () {
              scheduleSync(
                180
              );

              window.setTimeout(
                syncGiftSystem,
                550
              );
            },
            {
              once:
                true
            }
          );
        }

        return originalSend.apply(
          this,
          arguments
        );
      };
  }

  /* ========================================================
     FORMULARIOS
     ======================================================== */

  function installFormListener() {
    document.addEventListener(
      'submit',
      function (
        event
      ) {
        const form =
          event.target;

        if (
          form &&
          form.matches &&
          form.matches(
            'form[action*="/cart/add"]'
          )
        ) {
          scheduleSync(
            300
          );

          window.setTimeout(
            syncGiftSystem,
            750
          );
        }
      },
      true
    );
  }

  /* ========================================================
     OBSERVAR CAMBIOS DEL DOM
     ======================================================== */

  function installObserver() {
    if (
      window.__NOVA_GIFT_OBSERVER_V19__
    ) {
      return;
    }

    window.__NOVA_GIFT_OBSERVER_V19__ =
      true;

    const observer =
      new MutationObserver(
        function () {
          window.clearTimeout(
            window.__novaGiftDecorateTimer
          );

          window.__novaGiftDecorateTimer =
            window.setTimeout(
              decorateGiftInCart,
              100
            );
        }
      );

    observer.observe(
      document.body,
      {
        childList:
          true,

        subtree:
          true
      }
    );
  }

  /* ========================================================
     INICIAR
     ======================================================== */

  function initialize() {
    removeLegacyPopups();

    installFetchListener();

    installXhrListener();

    installFormListener();

    installObserver();

    scheduleSync(
      100
    );

    window.setTimeout(
      syncGiftSystem,
      500
    );

    window.setTimeout(
      syncGiftSystem,
      1100
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once:
          true
      }
    );
  } else {
    initialize();
  }

  window.addEventListener(
    'pageshow',
    function () {
      scheduleSync(
        100
      );
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      scheduleSync(
        100
      );
    }
  );

  document.addEventListener(
    'visibilitychange',
    function () {
      if (
        !document.hidden
      ) {
        scheduleSync(
          100
        );
      }
    }
  );

})();